import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import {
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Snackbar,
  Alert,
  Grid,
  Paper,
  Box,
  Container,
  Toolbar, // Agregar este import
} from '@mui/material';
import { getObligacionNormativa } from '../../componentes/http/actions/ObligacionAction';
import AppBarPublico from '../../componentes/navegacion/AppBarPublico';

const DetalleObligacionesPublico = () => {
  const { idNormativa } = useParams();
  const [obligaciones, setObligaciones] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const fetchObligaciones = useCallback(() => {
    setIsLoading(true);
    
    // Para usuarios públicos, no pasar token (será null)
    getObligacionNormativa(null, idNormativa)
      .then((response) => {
        setObligaciones(response);
      })
      .catch((error) => {
        console.error("Error fetching obligaciones:", error);
        setSnackbar({
          open: true,
          message: "Error al cargar las obligaciones",
          severity: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
        setInitialDataLoaded(true);
      });
  }, [idNormativa]);

  useEffect(() => {
    if (idNormativa) {
      fetchObligaciones();
    }
  }, [fetchObligaciones, idNormativa]);

  const nombreNormativa = obligaciones.length > 0 ? obligaciones[0].nombreNormativa : null;

  return (
    <>
      {/* AppBar público */}
      <AppBarPublico />
      
      {/* Espaciado para compensar el AppBar fijo */}
      <Toolbar />
      
      <Container maxWidth="lg">
        <Box sx={{ mt: 4, mb: 4 }}>
          <Grid container direction="column" spacing={2}>
            <Paper sx={{ p: 3, mb: 3 }}>
              <Grid item>
                <Typography variant="h4">
                  Obligaciones
                </Typography>
                {nombreNormativa && (
                <Typography variant="h6" sx={{ mt: 1 }}>
                  Normativa: {nombreNormativa}
                </Typography>
                )}
              </Grid>

              {isLoading && !initialDataLoaded ? (
                <Box display="flex" justifyContent="center" p={3}>
                  <CircularProgress />
                </Box>
              ) : obligaciones.length > 0 ? (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Descripción</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {obligaciones.map((obligacion) => (
                      <TableRow key={obligacion.id}>
                        <TableCell>{obligacion.descripcion}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <Typography>No hay obligaciones para esta normativa.</Typography>
              )}

              <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
              >
                <Alert
                  onClose={() => setSnackbar({ ...snackbar, open: false })}
                  severity={snackbar.severity}
                  sx={{ width: "100%" }}
                >
                  {snackbar.message}
                </Alert>
              </Snackbar>
            </Paper>
          </Grid>
        </Box>
      </Container>
    </>
  );
};

export default DetalleObligacionesPublico;